export const SUBMIT_WORK_START = 'SUBMIT_WORK_START';
export const SUBMIT_WORK_SUCCESS = 'SUBMIT_WORK_SUCCESS';
export const SUBMIT_WORK_END = 'SUBMIT_WORK_END';
